var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('error-queue-snackbar',{ref:"errors",attrs:{"timeout":_vm.timeout,"color":_vm.color}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }